// Bliss Pharma
export const BLISS_STRAINS = [
  {
    id: "bliss-og-kush-22",
    name: "OG Kush",
    producer: "Bliss Pharma",
    country: "Hiszpania",
    genetics: "Hybryda/Indica",
    lineage: "OG Kush × SFV OG IBL",
    thc: 22, cbd: 1.0,
    availability: "Brak", effect: "Pobudzające",
    aromas: ["Cytrusowy", "Korzenny", "Sosnowy"],
    description: "OG Kush to hybryda z przewagą indici od Bliss Pharma o THC 22%. Dominujący pinen odpowiada za świeży, sosnowy aromat, poprawia pamięć i zmniejsza stan zapalny. Cedren wnosi ciepłą, drzewną nutę, a eukaliptol wzmaga właściwości przeciwzapalne pinenu. Eukaliptol wspiera układ oddechowy, a mircen uzupełnia profil delikatną relaksacją mięśniową.",
    terpenes: { pinen: 64, mircen: 8, cedren: 17, eukaliptol: 11 },
    dominantTerpene: "Pinen", packaging: "10g"
  },
  {
    id: "bliss-strawberry-og-25",
    name: "Strawberry OG",
    producer: "Bliss Pharma",
    country: "Hiszpania",
    genetics: "Hybryda",
    lineage: "Bruce Banner × SFV OG",
    thc: 25, cbd: 1.0,
    availability: "Brak", effect: "Zrównoważone",
    aromas: ["Cytrusowy", "Drzewny", "Ziołowy"],
    description: "Rzadko dominujący w suszu nerolidol, wraz z limonenem odpowiadają za działanie poprawiające nastrój i przeciwdepresyjne. Wykazują też działanie przeciwzapalne, które nasila drugi najobfitszy terpen, pinen i, rzadkość wśród terpenów w konopiach, walenzen. Cedren domyka całość dodając charakterystycznego, drzewnego aromatu.",
    terpenes: { cedren: 24, nerolidol: 24, limonen: 7, humulen: 10, pinen: 20, walenzen: 15 },
    dominantTerpene: "Cedren", packaging: "10g"
  },
  {
    id: "bliss-papaya-boom-25",
    name: "Papaya Boom",
    producer: "Bliss Pharma",
    country: "Hiszpania",
    genetics: "Hybryda/Indica",
    lineage: "Jack Herer × Skunk × Kush",
    thc: 25, cbd: 1.0,
    availability: "Brak", effect: "Relaksujące",
    aromas: ["Owocowy", "Słodki", "Tropikalny"],
    description: "Dominujący w profilu terpenowym mircen gwarantuje nam uczucie zrelaksowania i zmniejszenie napięcia mięśniowego, a wraz z dość wysokim stężeniem THC sprawi, że susz będzie odpowiedni dla Pacjentów zmagających się z dolegliwościami bólowymi. Docenią go szczególnie Pacjenci z bólem związanym ze stanem zapalnym, bo wszystkie terpeny wykazują działanie redukujące proces zapalny, a kariofilen i limonen wykazują działanie poprawiające nastrój i samopoczucie.",
    descriptionEn: "Myrcene, the dominant terpene in the profile, provides a feeling of relaxation and reduces muscle tension. Together with the relatively high THC content, it makes this flower suitable for patients experiencing pain. It may be particularly appreciated by patients with inflammation-related pain, as all the terpenes in the profile exhibit anti-inflammatory effects, while caryophyllene and limonene help improve mood and well-being.",
    terpenes: { mircen: 47, limonen: 18, kariofilen: 14, humulen: 6 },
    dominantTerpene: "Mircen", packaging: "10g",
    dateAdded: "2026-09-25"
  }
];